<div [class.background-image]="showBackgroundImage$ | async" fxFill fxLayout="column">
   <!-- user name info -->
   <div *ngIf="showUsername$ | async" class="sam-full-width user-name" fxFlex="0 0 auto">
      {{ userFullName$ | async }}
   </div>

   <!-- private dn info-->
   <div *ngIf="showPrivateDn$ | async" class="sam-full-width private-dn" fxFlex="0 0 auto">
      <fa-icon [icon]="privateLineIcon"></fa-icon>
      {{ userDn$ | async }}
   </div>

   <!-- alternative device info -->
   <samweb-alternative-device-editor
      fxFlex="0 0 auto"
      [brickInstanceId]="brickInstanceId"
      *ngIf="showAlternativeDeviceEditor$ | async"
   ></samweb-alternative-device-editor>

   <!-- avatar -->
   <samweb-avatar
      *ngIf="showAvatar$ | async"
      [userId]="userId$ | async"
      class="reduce-avatar-size"
      fxFlex="1 1 auto"
   ></samweb-avatar>

   <!-- status dropdown -->
   <samweb-user-status-dropdown
      *ngIf="showStatusDropdown$ | async"
      [userId]="userId$ | async"
      fxFlex="0 0 auto"
   ></samweb-user-status-dropdown>
</div>
